import type {
  IStoreRankDetailsResData,
  IStoreRankDetailsVisualisSourceData,
  IStoreRankDetailsTablesSourceData,
} from '@/pages/intelligence/types/storeRank';
import type { IStoreRankDetailsCoreUIData } from '../types';

export const getStoreRankDetailsCoreUIData = (
  data: IStoreRankDetailsResData[],
): IStoreRankDetailsCoreUIData => {
  const result: IStoreRankDetailsCoreUIData = {
    sourceDataDimensions: [],
    visualisSourceData: [],
    tablesSourceData: [],
  };

  // console.log('getStoreRankDetailsCoreUIData-data', data);

  if (!Array.isArray(data)) return result;

  for (const item of data) {
    const date = item?.date;
    if (!date) continue;
    const ranks = item?.metric ?? [];
    const countryDetail = item?.country_detail ?? [];
    const sourceDataDimensionsMap: { [key: string]: boolean } = {};
    const visualisSourceDataItem: IStoreRankDetailsVisualisSourceData = {
      date,
    };
    const tablesSourceDataItem: IStoreRankDetailsTablesSourceData = {
      date,
      countryDetail,
    };

    // 判断此行是否有数据，无数据则不显示下拉展开按钮 noDataRecord
    let noDataRecord = true;
    for (const rank of ranks) {
      const metricKey = rank?.name;
      if (!metricKey) continue;
      if (!sourceDataDimensionsMap[metricKey]) {
        result.sourceDataDimensions.push(metricKey);
        sourceDataDimensionsMap[metricKey] = true;
      }

      const rankValue = rank?.rank;
      // 只要有一条数据，即显示下拉
      if (rankValue) {
        noDataRecord = false;
      }
      const rankRatioValue = rank?.rank_dod;
      visualisSourceDataItem[metricKey] = rankValue ?? Number.NaN;
      const metricObj = {
        value: rankValue ?? Number.NaN,
        ratioValue: rankRatioValue ?? Number.NaN,
      };
      // if (rank?.markets) {
      //   metricObj = {
      //     ...metricObj,
      //     markets: rank?.markets,
      //   };
      // }
      tablesSourceDataItem[metricKey] = metricObj;
    }

    // 如果有countryDetail，也需要判断是否有数据
    if (Array.isArray(countryDetail) && countryDetail?.length > 0) {
      for (const rank of countryDetail) {
        const metricKey = rank?.ranking;
        if (!metricKey) continue;
        // if (!sourceDataDimensionsMap[metricKey]) {
        //   result.sourceDataDimensions.push(metricKey);
        //   sourceDataDimensionsMap[metricKey] = true;
        // }

        const rankValue = rank?.dod;
        // 只要有一条数据，即显示下拉
        if (rankValue) {
          noDataRecord = false;
        }

        const marketsValue = rank?.markets;
        // 只要有一条数据，即显示下拉
        if (Array.isArray(marketsValue) && marketsValue?.length > 0) {
          noDataRecord = false;
        }

        // const rankRatioValue = rank?.rank_dod;
        // visualisSourceDataItem[metricKey] = rankValue ?? Number.NaN;
        // const metricObj = {
        //   value: rankValue ?? Number.NaN,
        //   ratioValue: rankRatioValue ?? Number.NaN,
        // };
        // tablesSourceDataItem[metricKey] = metricObj;
      }
    }

    tablesSourceDataItem.noDataRecord = noDataRecord;
    result.visualisSourceData.push(visualisSourceDataItem);
    result.tablesSourceData.push(tablesSourceDataItem);
  }

  return result;
};
